import React, { useRef, useState } from 'react';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
import { LiveBuyersBar } from './components/LiveBuyersBar';
import { useMetaPixel } from './hooks/useMetaPixel';
const CHECKOUT = 'https://recetario-idol.impultienda.ar/checkout';
const PRECIO = '17';
const VALOR_TOTAL = '57';
const tomos = [{
  n: 1,
  t: 'El Menú Secreto Antes de un Comeback',
  s: 'Lo que se cocina en la semana más exigente de un idol, receta por receta'
}, {
  n: 2,
  t: 'Desayunos de Entrenamiento',
  s: 'Desayunos coreanos calientes y con proteína, listos en menos de 15 minutos'
}, {
  n: 3,
  t: 'Comidas Entre Ensayos',
  s: 'Platos rápidos que se comen en 20 minutos y no te dejan con sueño'
}, {
  n: 4,
  t: 'Noches de Comfort Food',
  s: 'Los cuatro jjigae clásicos, en una sola olla y con el picante a tu medida'
}, {
  n: 5,
  t: 'Snacks de Maratón de Dramas',
  s: 'Tteokbokki, pollo frito coreano y todo lo que acompaña una maratón'
}, {
  n: 6,
  t: 'Comida y Postres para Celebrar con el Fandom',
  s: 'Galbi, bingsu y una mesa completa para compartir en grupo'
}];
const muestras = [{
  t: 'Bibimbap energético de camarín',
  d: 'Se arma la noche anterior y se mezcla recién al comer',
  tomo: 1
}, {
  t: 'Gukbap simplificado',
  d: 'Sopa con arroz lista en menos de 8 minutos',
  tomo: 2
}, {
  t: 'Japchae exprés',
  d: 'Fideos de vidrio salteados en una sola sartén',
  tomo: 3
}, {
  t: 'Kimchi jjigae clásico',
  d: 'El guiso coreano por excelencia, con kimchi bien fermentado',
  tomo: 4
}, {
  t: 'Tteokbokki clásico',
  d: 'El snack callejero más famoso de Corea, hecho en casa',
  tomo: 5
}];
const bonos = [{
  n: 1,
  t: 'Guía de Despensa Coreana Express',
  d: 'Qué comprar, sustitutos y dónde conseguir cada ingrediente.'
}, {
  n: 2,
  t: 'Planificador Semanal de Comidas Idol',
  d: 'Combina las recetas de los 6 tomos en una semana real, con lista de compras.'
}, {
  n: 3,
  t: 'Checklist de una Viewing Party Perfecta',
  d: 'Tiempos, cantidades y roles para organizar una reunión con el fandom.'
}, {
  n: 4,
  t: 'Glosario Visual de Banchan',
  d: 'Los acompañamientos coreanos y con qué plato va cada uno.'
}, {
  n: 5,
  t: 'Guía de Picante para Principiantes',
  d: 'Ajusta el picante de cada receta a tu tolerancia, sin perder sabor.'
}];
const faqs = [{
  q: '¿Necesito experiencia cocinando comida coreana?',
  a: 'No. Cada receta trae cantidades exactas y pasos numerados, y el recetario empieza por platos simples. Si es tu primera vez con estas recetas, la Guía de Despensa te dice qué comprar primero.'
}, {
  q: '¿Voy a conseguir los ingredientes?',
  a: 'Sí. Las recetas usan ingredientes que se consiguen fuera de Corea, y el Bono 1 te da sustitutos para cuando algo no aparece, más una guía de qué tipo de tienda buscar.'
}, {
  q: '¿Es una dieta o un plan para bajar de peso?',
  a: 'No. Es un recetario de cocina coreana real, organizado por momentos del día. No promete resultados de peso ni reemplaza la indicación de un nutricionista.'
}, {
  q: '¿Es muy picante?',
  a: 'Tú decides. Cada receta picante se puede hacer suave, y el Bono 5 te explica cómo bajar o subir el picante en cada plato del libro.'
}, {
  q: '¿Cómo lo recibo?',
  a: 'Apenas se aprueba el pago te llega un email con el acceso a los 6 tomos y los 5 bonos en PDF, para leerlos en el celular, la tablet o imprimirlos.'
}, {
  q: `¿Es un pago único?`,
  a: `Sí. Pagas ${PRECIO} USD una sola vez, convertidos a tu moneda local. No hay suscripción ni cobros futuros.`
}];
const slides = [{
  src: 'https://naturia-assets.pages.dev/recetario-idol/1-por-que-bibimbap.webp',
  alt: '¿Por qué bibimbap? Carbohidrato, proteína, vegetales y grasa buena en un solo recipiente'
}, {
  src: 'https://naturia-assets.pages.dev/recetario-idol/2-ingredientes.webp',
  alt: 'Ingredientes del bibimbap para 1 porción abundante'
}, {
  src: 'https://naturia-assets.pages.dev/recetario-idol/3-pasos-1-a-4.webp',
  alt: 'Cómo hacer el bibimbap, pasos 1 a 4'
}, {
  src: 'https://naturia-assets.pages.dev/recetario-idol/4-pasos-5-a-7.webp',
  alt: 'Cómo hacer el bibimbap, pasos 5 a 7'
}, {
  src: 'https://naturia-assets.pages.dev/recetario-idol/5-variacion-sin-carne.webp',
  alt: 'Variación sin carne: tofu firme salteado en cubos'
}];
const Carrusel = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [actual, setActual] = useState(0);
  const ir = (i: number) => {
    const el = ref.current;
    if (!el) return;
    const n = (i + slides.length) % slides.length;
    el.scrollTo({
      left: n * el.clientWidth,
      behavior: 'smooth'
    });
    setActual(n);
  };
  return <div className="relative mx-auto max-w-md" data-id="element-0" data-mp="zxk4d5ixqhho">
      <div ref={ref} onScroll={e => setActual(Math.round(e.currentTarget.scrollLeft / e.currentTarget.clientWidth))} className="flex snap-x snap-mandatory overflow-x-auto rounded-2xl shadow-xl [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-1" data-mp="zw90z6tejbr3">
        {slides.map((s, i) => <img key={s.src} src={s.src} alt={s.alt} width={900} height={1125} loading={i === 0 ? 'eager' : 'lazy'} className="h-auto w-full shrink-0 snap-center" data-id="element-2" data-mp="3gok6ztac6rsb" data-mpi={i} />)}
      </div>
      <button aria-label="Anterior" onClick={() => ir(actual - 1)} className="absolute left-2 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-slate-950/70 text-xl text-white" data-id="element-3" data-mp="206jwxm7xk89p">‹</button>
      <button aria-label="Siguiente" onClick={() => ir(actual + 1)} className="absolute right-2 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-slate-950/70 text-xl text-white" data-id="element-4" data-mp="29xo8ebyedazs">›</button>
      <div className="mt-4 flex justify-center gap-2" data-id="element-5" data-mp="2nvunybzhaoan">
        {slides.map((s, i) => <button key={s.src} aria-label={`Ir a la imagen ${i + 1}`} onClick={() => ir(i)} className={`h-2.5 rounded-full transition-all ${i === actual ? 'w-6 bg-violet-600' : 'w-2.5 bg-slate-300'}`} data-id="element-6" data-mp="2supddwrybb3q" data-mpi={i} />)}
      </div>
    </div>;
};
const Cta = ({
  children,
  full = false,
  href = CHECKOUT
}: {
  children: React.ReactNode;
  full?: boolean;
  href?: string;
}) => <a href={href} className={`inline-flex items-center justify-center rounded-xl bg-violet-600 px-8 py-4 text-center text-lg font-semibold text-white shadow-lg shadow-violet-600/30 transition hover:bg-violet-700 ${full ? 'w-full' : ''}`} data-id="element-7" data-mp="21ru519lt87dr">
    {children}
  </a>;
const ImgHueco = ({
  id,
  texto,
  medida
}: {
  id: string;
  texto: string;
  medida: string;
}) => <div id={id} className="flex aspect-[4/3] w-full flex-col items-center justify-center rounded-2xl border-2 border-dashed border-violet-300 bg-violet-50 p-6 text-center text-violet-700" data-id="element-8" data-mp="2kpem3uic21nt">
    <span className="font-semibold" data-id="element-9" data-mp="2tizzb9eunav4">{texto}</span>
    <span className="mt-1 text-sm" data-id="element-10" data-mp="2tkuler1ux90s">{medida}</span>
  </div>;
export function App() {
  useMetaPixel('1855882409099712');
  const [abierta, setAbierta] = useState<number | null>(0);
  return <div className="min-h-screen bg-white text-slate-900" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-11" data-mp="33hfv3potn8ay">
      <style data-id="element-12" data-mp="2yfqezvmqs4g0">{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Poppins:wght@500;600&display=swap'); h1,h2,h3{font-family:Poppins,sans-serif} html{scroll-behavior:smooth} @media (prefers-reduced-motion: reduce){html{scroll-behavior:auto}}`}</style>

      {/* Barra superior */}
      <div className="bg-slate-950 px-4 py-2 text-center text-sm text-white" data-id="element-13" data-mp="387ta4e9bxpbt">
        Oferta de lanzamiento: <span className="font-semibold text-violet-300" data-id="element-14" data-mp="3d6d0cquyhn9z">de {VALOR_TOTAL} USD a {PRECIO} USD</span> por tiempo limitado
      </div>

      {/* 1. Hero */}
      <section className="bg-slate-950 px-5 pb-16 pt-12 text-white" data-id="element-15" data-mp="344n8jjx5wmbo">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-16" data-mp="2pfhc23ppla7h">
          <span className="inline-block rounded-full bg-violet-500/15 px-4 py-1 text-sm font-medium text-violet-300" data-id="element-17" data-mp="2ue22xcj2mhj9">
            6 tomos + 5 bonos · Recetas coreanas reales
          </span>
          <h1 className="mt-5 text-4xl font-semibold leading-tight md:text-5xl" data-id="element-18" data-mp="2ggn9zxtlzrmj">
            <span className="block" data-id="element-19" data-mp="2khyzm3chgcuq">Tu Recetario Coreano</span>
            <span className="mt-2 block" data-id="element-20" data-mp="30uc9e66c0ene">
              <span className="text-violet-400" data-id="element-21" data-mp="30tasvm6jqzya">LISTO PARA USAR</span> desde el primer tomo.
            </span>
          </h1>
          <p className="mt-5 text-lg text-slate-300" data-id="element-22" data-mp="2qwxtc7oblrvm">
            <span className="font-semibold text-white" style={{
            fontWeight: "700",
            color: "#854CA1"
          }} data-id="element-23" data-mp="2qvcwucig3yv4">Recetario Idol - Cocina Coreana Real</span> reúne en un solo sistema lo que comen los idols de K-pop en cada momento de su rutina: desayunos, comidas entre ensayos, cenas, snacks de maratón y comida para celebrar.
          </p>
          <div className="mt-8 w-full max-w-md" data-id="element-24" data-mp="286ptbyfx3hjn">
            <img id="img-producto" src="https://cdn.magicpatterns.com/uploads/2Qj6T7W4rnWesuZnk5fSNZ/finally_-_Editado.webp" alt="Caja del Recetario Idol: Cocina Coreana Real con los 6 tomos" className="mx-auto h-auto w-full" data-id="element-25" data-mp="287hqhdp5xnc1" />
          </div>
          <div className="mt-8 w-full sm:w-auto" data-id="element-26" data-mp="1u7gqs1kmwly5">
            <Cta full href="#oferta" data-id="element-27" data-mp="9p65a2bo2jta">¡Sí! Quiero el recetario</Cta>
          </div>
          <p className="mt-4 text-sm text-slate-400" data-id="element-28" data-mp="9r8y0u47er1p">
            <span className="text-slate-500 line-through" data-id="element-29" data-mp="dp6ixkqxyqza">{VALOR_TOTAL} USD</span>{' '}
            <span className="font-semibold text-white" data-id="element-30" data-mp="iqm5jh8rp5js">{PRECIO} USD</span> · pago único
          </p>
        </div>
      </section>

      {/* 2. Dolor */}
      <section className="px-5 py-16" data-id="element-31" data-mp="nmb87tg332kb">
        <div className="mx-auto max-w-3xl" data-id="element-32" data-mp="3m72rep5zk5np">
          <h2 className="text-center text-3xl font-semibold" data-id="element-33" data-mp="3m485et7bqcs6">¿Te suena familiar?</h2>
          <ul className="mt-8 space-y-4 text-lg" data-id="element-34" data-mp="3r5xl4m5hreml">
            {['Ves un plato en un drama, buscas la receta y encuentras diez versiones que no coinciden.', 'La receta pide ingredientes que no tienes idea de dónde conseguir.', 'Terminas cocinando siempre lo mismo porque no sabes por dónde seguir.', 'El picante te queda imposible de comer o completamente sin gracia.'].map(p => <li key={p} className="flex gap-3 rounded-xl bg-slate-100 p-4" data-id="element-35" data-mp="38e4nufje3792">
                <span className="mt-1 h-3 w-3 shrink-0 rounded-full bg-violet-600" data-id="element-36" data-mp="2f7djskc0kwln" />
                <span data-id="element-37" data-mp="2k683doht2p6t">{p}</span>
              </li>)}
          </ul>
          <p className="mt-8 text-center text-lg" data-id="element-38" data-mp="2k4n81wno327w">
            Ya sabes que te encanta la comida coreana. <span className="font-semibold" data-id="element-39" data-mp="2p5ugzz1jq7g5">Lo que falta es un sistema.</span>
          </p>
        </div>
      </section>

      {/* 3. Lo que incluye */}
      <section id="incluye" className="bg-slate-950 px-5 py-16 text-white" data-id="element-40" data-mp="1wgvwwwdv4v87">
        <div className="mx-auto max-w-6xl" data-id="element-41" data-mp="1wesxjlqtlpqt">
          <p className="text-center text-sm font-medium uppercase tracking-wider text-violet-300" data-id="element-42" data-mp="21gs0wvmk8mnr">Lo que incluye</p>
          <h2 className="mt-2 text-center text-3xl font-semibold" data-id="element-43" data-mp="26e1oe5qe2o8y">El recetario completo de 6 tomos</h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-slate-300" data-id="element-44" data-mp="2b734gh2c0tu4">
            Organizado por momento del día, como la rutina de un idol. Elige el momento, abre el tomo y cocina.
          </p>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-45" data-mp="1ino5p5tp21r1">
            {tomos.map(t => <div key={t.n} className="rounded-2xl border border-slate-800 bg-slate-900 p-6" data-id="element-46" data-mp="3vy7gy79o91zx">
                <span className="text-sm font-medium text-violet-300" data-id="element-47" data-mp="3rz8b8kg4917f">Tomo {t.n}</span>
                <h3 className="mt-2 text-xl font-semibold" data-id="element-48" data-mp="3mxrduywubwvl">{t.t}</h3>
                <p className="mt-2 text-slate-300" data-id="element-49" data-mp="3hzzlk3saa8qv">{t.s}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 4. Muestras */}
      <section className="px-5 py-16" data-id="element-50" data-mp="3d27jwi1u789h">
        <div className="mx-auto max-w-4xl" data-id="element-51" data-mp="389xx3aw0qobf">
          <h2 className="text-center text-3xl font-semibold" data-id="element-52" data-mp="388v50zmymftx">Un vistazo a lo que vas a cocinar</h2>
          <div className="mt-8 space-y-3" data-id="element-53" data-mp="349dxm0nz38m4">
            {muestras.map(m => <div key={m.t} className="flex flex-col justify-between gap-1 rounded-xl border border-slate-200 p-5 sm:flex-row sm:items-center" data-id="element-54" data-mp="2z9hv65uxbp8o">
                <div data-id="element-55" data-mp="2u9n5g5mvx5p7">
                  <h3 className="font-semibold" data-id="element-56" data-mp="2uc9anymaz949">{m.t}</h3>
                  <p className="text-slate-600" data-id="element-57" data-mp="2pc3fi8gtr4hf">{m.d}</p>
                </div>
                <span className="text-sm font-medium text-violet-700" data-id="element-58" data-mp="2fmwusdn9u0qy">Tomo {m.tomo}</span>
              </div>)}
          </div>
          <p className="mt-6 text-center text-slate-600" data-id="element-59" data-mp="2knkgcjsqdpds">Y más de 30 recetas en total, todas paso a paso.</p>
        </div>
      </section>

      {/* 4b. Carrusel: una receta por dentro */}
      <section className="bg-slate-950 px-5 py-16 text-white" data-id="element-60" data-mp="2anlc2z3cgl6q">
        <div className="mx-auto max-w-6xl" data-id="element-61" data-mp="2ydxr0tx0bi6t">
          <p className="text-center text-sm font-medium uppercase tracking-wider text-violet-300" data-id="element-62" data-mp="2yez3n2to8cqn">Así se ve por dentro</p>
          <h2 className="mt-2 text-center text-3xl font-semibold" data-id="element-63" data-mp="33c90h3je3qoi">Una receta completa, página por página</h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-slate-300" data-id="element-64" data-mp="2pjjdoww1ehqc">El bibimbap energético del Tomo 1, tal como lo vas a encontrar en el recetario.</p>
          <div className="mt-10" data-id="element-65" data-mp="3hcjv8hntlpey"><Carrusel data-id="element-66" data-mp="3hb8pwdeq89lq" /></div>
        </div>
      </section>

      {/* 5. Bonos */}
      <section className="bg-slate-100 px-5 py-16" data-id="element-67" data-mp="3m4jxwhv9ywf8">
        <div className="mx-auto max-w-6xl" data-id="element-68" data-mp="3m5czz5jagxr1">
          <h2 className="text-center text-3xl font-semibold" data-id="element-69" data-mp="1anhsjhxhmdue">Y además, 5 bonos incluidos</h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-slate-600" data-id="element-70" data-mp="15q85g8xkme9q">Vienen con el recetario, sin costo extra.</p>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-71" data-mp="1kd1ewxkespu0">
            {bonos.map(b => <div key={b.n} className="rounded-2xl bg-white p-6 shadow-sm" data-id="element-72" data-mp="1fgko1vltrxd8">
                <span className="text-sm font-medium text-violet-700" data-id="element-73" data-mp="rovq9zq8igow">Bono {b.n}</span>
                <h3 className="mt-2 text-lg font-semibold" data-id="element-74" data-mp="mqub3pvxj1ip">{b.t}</h3>
                <p className="mt-2 text-slate-600" data-id="element-75" data-mp="msorcqw9a5gg">{b.d}</p>
                <p className="mt-4 text-sm font-semibold text-green-700" data-id="element-76" data-mp="11owg84ilzv22">✓ Incluido</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 6. No es otro recetario */}
      <section className="px-5 py-16" data-id="element-77" data-mp="2d28iiayq05m4">
        <div className="mx-auto max-w-6xl" data-id="element-78" data-mp="2d170tnn78kvf">
          <h2 className="text-center text-3xl font-semibold" data-id="element-79" data-mp="284gkcz7hfn9h">Esto NO es otro recetario más</h2>
          <p className="mt-2 text-center text-lg text-slate-600" data-id="element-80" data-mp="hncxuxrfdyr9">Es un sistema completo para tener comida coreana real en tu mesa todos los días.</p>
          <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-81" data-mp="mm6cwumd1xtj">
            {[['Recetas reales, paso a paso', 'Cantidades exactas y pasos numerados, sin adivinar.'], ['Ingredientes que se consiguen', 'Pensado para cocinar fuera de Corea, con sustitutos.'], ['Organizado por momento del día', 'Desayuno, entre ensayos, noche, maratón y celebración.']].map(([t, d]) => <div key={t} className="rounded-2xl border border-slate-200 p-6 text-center" data-id="element-82" data-mp="15k8tqm4r8og9">
                <h3 className="text-lg font-semibold" data-id="element-83" data-mp="1abqtj6v1kizn">{t}</h3>
                <p className="mt-2 text-slate-600" data-id="element-84" data-mp="1adljizl671al">{d}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. Oferta */}
      <div id="oferta" aria-hidden="true" data-id="element-85" data-mp="1jcp11z4ov8mz" />
      <LiveBuyersBar data-id="element-86" data-mp="1je0765llwsh9" />
      <section className="bg-slate-950 px-5 py-16 text-white" data-id="element-87" data-mp="1jacc320ijy0f">
        <div className="mx-auto max-w-2xl text-center" data-id="element-88" data-mp="1obrwqsys42ia">
          <p className="text-sm font-medium uppercase tracking-wider text-violet-300" data-id="element-89" data-mp="1yex5pdninvqr">Oferta especial de lanzamiento</p>
          <h2 className="mt-2 text-3xl font-semibold" data-id="element-90" data-mp="1tf2hjhv4lk9e">Recetario Idol completo</h2>
          <img src="https://cdn.magicpatterns.com/uploads/2Qj6T7W4rnWesuZnk5fSNZ/finally_-_Editado.webp" alt="Caja del Recetario Idol: Cocina Coreana Real con los 6 tomos" className="mx-auto mt-8 h-auto w-full max-w-md" data-id="element-91" data-mp="1oghezbseiohs" />
          <ul className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 font-semibold" data-id="element-92" data-mp="2h4n2g6auarlb">
            {['6 tomos completos', '5 bonos incluidos', 'Más de 30 recetas', 'Ingredientes que se consiguen'].map(x => <li key={x} className="flex items-center gap-2" data-id="element-93" data-mp="27etsf9qcikj6"><span className="text-violet-400" data-id="element-94" data-mp="27dip1b0tbesl">✓</span>{x}</li>)}
          </ul>
          <p className="mt-8 flex flex-wrap items-baseline justify-center gap-x-4" data-id="element-95" data-mp="23e1i0d5qm9lb">
            <span className="text-2xl font-semibold text-slate-500 line-through" data-id="element-96" data-mp="2zxqyfybj5gj3">{VALOR_TOTAL} USD</span>
            <span className="text-6xl font-semibold text-violet-400" data-id="element-97" data-mp="2v3wk7aep1tre">{PRECIO}</span>
            <span className="text-xl font-semibold text-violet-400" data-id="element-98" data-mp="t98gso6599gs">USD HOY</span>
          </p>
          <p className="mt-2 text-sm text-slate-300" data-id="element-99" data-mp="y5ywhae1e31o">Pagas el equivalente en tu moneda local</p>
          <div className="mx-auto mt-8 max-w-lg" data-id="element-100" data-mp="jh2sbof3pa6c"><Cta full data-id="element-101" data-mp="jg1g3gmcmhn1">⚡ ¡Sí! Lo quiero hoy</Cta></div>
          <p className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium uppercase tracking-wide text-slate-300" data-id="element-102" data-mp="ogfbnz6rjz46">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap" style={{
            fontSize: "10px"
          }} data-id="element-103" data-mp="ajip49xoh3t3"><LockIcon className="h-4 w-4 text-slate-400" aria-hidden="true" data-id="element-104" data-mp="fefvf93koz2a" /> Pago seguro</span>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap" style={{
            fontSize: "10px"
          }} data-id="element-105" data-mp="lcodvnly3pt"><ShieldCheckIcon className="h-4 w-4 text-slate-400" aria-hidden="true" data-id="element-106" data-mp="5kfgygmeihgw" /> Garantía de 7 días</span>
          </p>
        </div>
      </section>

      {/* 9. Garantía */}
      <section className="bg-slate-100 px-5 py-12" data-id="element-107" data-mp="1zvu7v0r5emy8">
        <div className="mx-auto max-w-3xl text-center" data-id="element-108" data-mp="3ke51xoe6lxep">
          <h2 className="text-2xl font-semibold" data-id="element-109" data-mp="3keoawflutbgl">Garantía de 7 días</h2>
          <p className="mt-3 text-slate-700" data-id="element-110" data-mp="3fgcz3zc00qvq">
            Abrís los 6 tomos. Revisás los 5 bonos. Si en 7 días no es lo que esperabas, te devolvemos el 100%.

Si en los primeros días algo no te funciona, escríbenos contándonos qué receta probaste y te ayudamos a resolverlo!
          </p>
        </div>
      </section>

      {/* 10. FAQ */}
      <section className="px-5 py-16" data-id="element-111" data-mp="71l64ofvduda">
        <div className="mx-auto max-w-3xl" data-id="element-112" data-mp="2yg8p0ancivi">
          <h2 className="text-center text-3xl font-semibold" data-id="element-113" data-mp="2xn8yja3utmv">Preguntas frecuentes</h2>
          <div className="mt-8 space-y-3" data-id="element-114" data-mp="gx62a5y9c0f4">
            {faqs.map((f, i) => <div key={f.q} className="rounded-xl border border-slate-200" data-id="element-115" data-mp="by3avob79spm" data-mpi={i}>
                <button className="flex w-full items-center justify-between gap-4 p-5 text-left font-semibold" onClick={() => setAbierta(abierta === i ? null : i)} data-id="element-116" data-mp="2ip1ceh4v7wv8">
                  {f.q}
                  <span className="text-violet-700" data-id="element-117" data-mp="2dsax3w0vx5av">{abierta === i ? '−' : '+'}</span>
                </button>
                {abierta === i && <p className="px-5 pb-5 text-slate-700" data-id="element-118" data-mp="1wvdgk2r31k3a">{f.a}</p>}
              </div>)}
          </div>
        </div>
      </section>

      {/* 11. Cierre */}
      <section className="bg-slate-950 px-5 py-16 text-center text-white" data-id="element-119" data-mp="21oosgiar4r22">
        <div className="mx-auto max-w-3xl" data-id="element-120" data-mp="26kdls3w6hbpx">
          <h2 className="text-3xl font-semibold" data-id="element-121" data-mp="18xy2qxo3s609">Una última pregunta</h2>
          <p className="mt-4 text-lg text-slate-300" data-id="element-122" data-mp="18zr90but0o7q">
            ¿Vas a seguir buscando recetas sueltas cada vez que se te antoje un plato coreano, o vas a abrir un solo
            recetario con todo listo para empezar hoy?
          </p>
          <p className="mt-6" data-id="element-123" data-mp="1nuxe8wm2sj00"><span className="text-slate-500 line-through" data-id="element-124" data-mp="1nvgxcgngpdfm">{VALOR_TOTAL} USD</span>{' '}<span className="text-3xl font-semibold" data-id="element-125" data-mp="2ubj9f58d18as">{PRECIO} USD</span></p>
          <div className="mt-6" data-id="element-126" data-mp="2uddnq0p4m25w"><Cta data-id="element-127" data-mp="2za3zibtwebli">¡Sí! Lo quiero hoy</Cta></div>
          <p className="mt-3 text-sm text-slate-400" data-id="element-128" data-mp="2z917g0kua340">Pago único. Sin suscripción. Acceso inmediato.</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="px-5 py-8 text-center text-sm text-slate-500" data-id="element-129" data-mp="io60e4qxy4cr">
        <p data-id="element-130" data-mp="iq0lbj27pwgu">© 2026 Naturia. Todos los derechos reservados.</p>
        <p className="mx-auto mt-2 max-w-2xl" data-id="element-131" data-mp="dw5w603u8pad">
          Recetas inspiradas en patrones generales de la industria del entretenimiento coreano. Naturia no tiene relación
          con ningún artista, grupo ni agencia de K-pop. Este recetario no es un plan de alimentación ni reemplaza la
          indicación de un profesional de la salud.
        </p>
      </footer>
    </div>;
}